// @flow

import * as React from "react";

function LoadingScreen(): React.Node {
    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 64px)", width: "100%"}}>
            <div style={{
                width: "56px", height: "56px", borderRadius: "50%",
                border: "4px solid #dce7d6", borderTopColor: "#224514",
                animation: "app-spin 0.8s linear infinite", marginBottom: "20px"
            }}></div>
            <div style={{color: "#8892a0", fontSize: "0.95rem"}}>Loading…</div>
        </div>
    );
}

export default LoadingScreen;
